export const nav_items = [
  {
    name: "About us",
    link: "/about"
  },
  {
    name: "Top Products",
    link: "/top-products"
  },
  {
    name: "Products",
    link: "/products"
  },
  {
    name: "Yangiliklar",
    link: "/blog"
  },
  {
    name: "Foydalanish shartlari",
    link: "/terms-of-use"
  }
]

export const numbers = [
  {
    number: 15,
    text: "Наш опыть в этой сфере 15 лет"
  },
  {
    number: 300,
    text: "У нас есть более 300 видов товаров"
  },
  {
    number: 10000,
    text: "счастливых клиентов"
  }
]

export const langs = ["en", "ru", "uz"];

export const main_section_pages = [
  {
    title: "Продукцию «Pero» 1",
    text: "Мы верим, что каждый имеет возможность пользоваться продукцией самого высокого качества, поэтому наши сильные бренды делают качество «Pero» доступным."
  },
  {
    title: "Продукцию «Pero» 2 ",
    text: "Мы верим, что каждый имеет возможность пользоваться продукцией самого высокого качества, поэтому наши сильные бренды делают качество «Pero» доступным."
  },
  {
    title: "Продукцию «Pero» 3",
    text: "Мы верим, что каждый имеет возможность пользоваться продукцией самого высокого качества, поэтому наши сильные бренды делают качество «Pero» доступным."
  },
  {
    title: "Продукцию «Pero» 4",
    text: "Мы верим, что каждый имеет возможность пользоваться продукцией самого высокого качества, поэтому наши сильные бренды делают качество «Pero» доступным."
  },
  {
    title: "Продукцию «Pero» 5",
    text: "Мы верим, что каждый имеет возможность пользоваться продукцией самого высокого качества, поэтому наши сильные бренды делают качество «Pero» доступным."
  }
].reverse();

export const products = [
  {
    title: "Бумажные продукции",
    image_url: "/assets/images/products/1.png",
  },
  {
    title: "Туалетные бумаги",
    image_url: "/assets/images/products/2.png",
  },
  {
    title: "Диспенсеры",
    image_url: "/assets/images/products/3.png",
  },
  {
    title: "Бумажные продукции",
    image_url: "/assets/images/products/1.png",
  },
  {
    title: "Бумажные продукции last",
    image_url: "/assets/images/products/1.png",
  },
  
]

export const about_icons = [
  {
    icon_url: "/assets/icons/about-quality.png",
    title: "Высокое качество",
    text: "Контроль качества изделий и отбраковка на этапе производства, прохождение ОТК, соответствие ГОСТам и стандартам качества"
  },
  {
    icon_url: "/assets/icons/about-shield.png",
    title: "Безопасность",
    text: "Вся наша продукция проходит тестирование и сертификацию в соответствии со стандартами мирового уровня"
  },
  {
    icon_url: "/assets/icons/about-eye.png",
    title: "Новшества и инновации",
    text: "Наши товары всегда многофункциональны и идут в ногу со временем, отвечая на запросы современных требовательынх пользователей"
  },
  
]

export const products_page = [
  {
    title: "Топ 1",
    text: "Мы верим, что каждый имеет возможность пользоваться продукцией самого высокого качества, поэтому наши сильные бренды делают качество «Pero» доступным.",
    image_url: "/assets/images/product-page-demo.png",
    comment:  {
      user_name: "Sadulla Kobiljonov",
      who: "Pero companoiyasi mijozi",
      picture: "/assets/images/user-rounded.png",
      rate: 3
    }
  },
  {
    title: "Топ 2",
    text: "Мы верим, что каждый имеет возможность пользоваться продукцией самого высокого качества, поэтому наши сильные бренды делают качество «Pero» доступным.",
    image_url: "/assets/images/product-page-demo.png",
    comment:  {
      user_name: "Sadulla Kobiljonov",
      who: "Pero companoiyasi mijozi",
      picture: "/assets/images/user-rounded.png",
      rate: 5
    }
  },
  {
    title: "Топ 3",
    text: "Мы верим, что каждый имеет возможность пользоваться продукцией самого высокого качества, поэтому наши сильные бренды делают качество «Pero» доступным.",
    image_url: "/assets/images/product-page-demo.png",
    comment:  {
      user_name: "Sadulla Kobiljonov",
      who: "Pero companoiyasi mijozi",
      picture: "/assets/images/user-rounded.png",
      rate: 4
    }
  },
  {
    title: "Топ 4",
    text: "Мы верим, что каждый имеет возможность пользоваться продукцией самого высокого качества, поэтому наши сильные бренды делают качество «Pero» доступным.",
    image_url: "/assets/images/product-page-demo.png",
    comment:  {
      user_name: "Sadulla Kobiljonov",
      who: "Pero companoiyasi mijozi",
      picture: "/assets/images/user-rounded.png",
      rate: 1
    }
  },
  {
    title: "Топ 5",
    text: "Мы верим, что каждый имеет возможность пользоваться продукцией самого высокого качества, поэтому наши сильные бренды делают качество «Pero» доступным.",
    image_url: "/assets/images/product-page-demo.png",
    comment:  {
      user_name: "Sadulla Kobiljonov",
      who: "Pero companoiyasi mijozi",
      picture: "/assets/images/user-rounded.png",
      rate: 3
    }
  }
]

export const all_products = [
  {
    image_url: "/assets/images/product-demo.png",
    title: "Бумажные cалфетки (Asian Pack Aroma) 310"
  },
  {
    image_url: "/assets/images/product-demo.png",
    title: "Бумажные cалфетки (Asian Pack Aroma) 310"
  },
  {
    image_url: "/assets/images/product-demo.png",
    title: "Бумажные cалфетки (Asian Pack Aroma) 310"
  },
  {
    image_url: "/assets/images/product-demo.png",
    title: "Бумажные cалфетки (Asian Pack Aroma) 310"
  },
  {
    image_url: "/assets/images/product-demo.png",
    title: "Бумажные cалфетки (Asian Pack Aroma) 310"
  },
  {
    image_url: "/assets/images/product-demo.png",
    title: "Бумажные cалфетки (Asian Pack Aroma) 310"
  },
  {
    image_url: "/assets/images/product-demo.png",
    title: "Бумажные cалфетки (Asian Pack Aroma) 310"
  },
  {
    image_url: "/assets/images/product-demo.png",
    title: "Бумажные cалфетки (Asian Pack Aroma) 310"
  },
  {
    image_url: "/assets/images/product-demo.png",
    title: "Бумажные cалфетки (Asian Pack Aroma) 310"
  },
  {
    image_url: "/assets/images/product-demo.png",
    title: "Бумажные cалфетки (Asian Pack Aroma) 310"
  },
  {
    image_url: "/assets/images/product-demo.png",
    title: "Бумажные cалфетки (Asian Pack Aroma) 310"
  },
  {
    image_url: "/assets/images/product-demo.png",
    title: "Бумажные cалфетки (Asian Pack Aroma) 310"
  },
  {
    image_url: "/assets/images/product-demo.png",
    title: "Бумажные cалфетки (Asian Pack Aroma) 310"
  },
  {
    image_url: "/assets/images/product-demo.png",
    title: "Бумажные cалфетки (Asian Pack Aroma) 310"
  }
];

export const videos = [
  "/assets/videos/1.avi",
  "/assets/videos/2.avi",
  "/assets/videos/3.avi"
];

export const product_categories = [
  "Бумажные продукции",
  "Бумажные полотенца",
  "Диспансер к столу",
  "Диспансер к столу",
  "Диспансер к столу",
  "Диспансер к столу",
  "Диспансер к столу",
  "Диспансер к столу",
  "Диспансер к столу",
  "Диспансер к столу",
]

export const footer_links =  [
  {
    title: "Company",
    links: [
      "/about",
      "/products",
      "#contact",
      "/blog"
    ]
  },
  {
    title: "Terms",
    links: [
      "#videos",
      "#products",
      "/terms-of-use"
    ]
  },
  {
    title: "Contact",
    links: [
      "",
      "mailto:info@pero.uz",
      "tel:+998988884446",
      "tel:+998981260919"
    ]
  }
]


export const blogs = [
  {
    title: "A symbol of hope for global unity 1",
    date: "24 Oct, 2021",
    image_url: "/assets/images/blog-demo.png"
  },
  {
    title: "A symbol of hope for global unity 2",
    date: "24 Oct, 2021",
    image_url: "/assets/images/blog-demo.png"
  },
  {
    title: "A symbol of hope for global unity 3",
    date: "24 Oct, 2021",
    image_url: "/assets/images/blog-demo.png"
  },
  {
    title: "A symbol of hope for global unity 4",
    date: "24 Oct, 2021",
    image_url: "/assets/images/blog-demo.png"
  },
  {
    title: "A symbol of hope for global unity 5",
    date: "24 Oct, 2021",
    image_url: "/assets/images/blog-demo.png"
  },
  {
    title: "A symbol of hope for global unity 6",
    date: "24 Oct, 2021",
    image_url: "/assets/images/blog-demo.png"
  },
  {
    title: "A symbol of hope for global unity 7",
    date: "24 Oct, 2021",
    image_url: "/assets/images/blog-demo.png"
  },
  {
    title: "A symbol of hope for global unity 8",
    date: "24 Oct, 2021",
    image_url: "/assets/images/blog-demo.png"
  },
  {
    title: "A symbol of hope for global unity 9",
    date: "24 Oct, 2021",
    image_url: "/assets/images/blog-demo.png"
  },
  {
    title: "A symbol of hope for global unity 10",
    date: "24 Oct, 2021",
    image_url: "/assets/images/blog-demo.png"
  },
  {
    title: "A symbol of hope for global unity 11",
    date: "24 Oct, 2021",
    image_url: "/assets/images/blog-demo.png"
  },
  {
    title: "A symbol of hope for global unity 12",
    date: "24 Oct, 2021",
    image_url: "/assets/images/blog-demo.png"
  },
  {
    title: "A symbol of hope for global unity 13",
    date: "24 Oct, 2021",
    image_url: "/assets/images/blog-demo.png"
  },
  {
    title: "A symbol of hope for global unity 14",
    date: "24 Oct, 2021",
    image_url: "/assets/images/blog-demo.png"
  },
  {
    title: "A symbol of hope for global unity 15",
    date: "24 Oct, 2021",
    image_url: "/assets/images/blog-demo.png"
  },
  {
    title: "A symbol of hope for global unity 16",
    date: "24 Oct, 2021",
    image_url: "/assets/images/blog-demo.png"
  },
  {
    title: "A symbol of hope for global unity 17",
    date: "24 Oct, 2021",
    image_url: "/assets/images/blog-demo.png"
  },
  {
    title: "A symbol of hope for global unity 18",
    date: "24 Oct, 2021",
    image_url: "/assets/images/blog-demo.png"
  },
  {
    title: "A symbol of hope for global unity 19",
    date: "24 Oct, 2021",
    image_url: "/assets/images/blog-demo.png"
  },
  {
    title: "A symbol of hope for global unity 20",
    date: "24 Oct, 2021",
    image_url: "/assets/images/blog-demo.png"
  },
  {
    title: "A symbol of hope for global unity 22",
    date: "24 Oct, 2021",
    image_url: "/assets/images/blog-demo.png"
  },
  {
    title: "A symbol of hope for global unity 23",
    date: "24 Oct, 2021",
    image_url: "/assets/images/blog-demo.png"
  },
  {
    title: "A symbol of hope for global unity 1",
    date: "24 Oct, 2021",
    image_url: "/assets/images/blog-demo.png"
  },
  {
    title: "A symbol of hope for global unity 2",
    date: "24 Oct, 2021",
    image_url: "/assets/images/blog-demo.png"
  },
  {
    title: "A symbol of hope for global unity 3",
    date: "24 Oct, 2021",
    image_url: "/assets/images/blog-demo.png"
  },
  {
    title: "A symbol of hope for global unity 4",
    date: "24 Oct, 2021",
    image_url: "/assets/images/blog-demo.png"
  },
  {
    title: "A symbol of hope for global unity 5",
    date: "24 Oct, 2021",
    image_url: "/assets/images/blog-demo.png"
  },
  {
    title: "A symbol of hope for global unity 6",
    date: "24 Oct, 2021",
    image_url: "/assets/images/blog-demo.png"
  },
  {
    title: "A symbol of hope for global unity 7",
    date: "24 Oct, 2021",
    image_url: "/assets/images/blog-demo.png"
  },
  {
    title: "A symbol of hope for global unity 8",
    date: "24 Oct, 2021",
    image_url: "/assets/images/blog-demo.png"
  },
  {
    title: "A symbol of hope for global unity 9",
    date: "24 Oct, 2021",
    image_url: "/assets/images/blog-demo.png"
  },
  {
    title: "A symbol of hope for global unity 10",
    date: "24 Oct, 2021",
    image_url: "/assets/images/blog-demo.png"
  },
  {
    title: "A symbol of hope for global unity 11",
    date: "24 Oct, 2021",
    image_url: "/assets/images/blog-demo.png"
  },
  {
    title: "A symbol of hope for global unity 12",
    date: "24 Oct, 2021",
    image_url: "/assets/images/blog-demo.png"
  },
  {
    title: "A symbol of hope for global unity 13",
    date: "24 Oct, 2021",
    image_url: "/assets/images/blog-demo.png"
  },
  {
    title: "A symbol of hope for global unity 14",
    date: "24 Oct, 2021",
    image_url: "/assets/images/blog-demo.png"
  },
  {
    title: "A symbol of hope for global unity 15",
    date: "24 Oct, 2021",
    image_url: "/assets/images/blog-demo.png"
  },
  {
    title: "A symbol of hope for global unity 16",
    date: "24 Oct, 2021",
    image_url: "/assets/images/blog-demo.png"
  },
  {
    title: "A symbol of hope for global unity 17",
    date: "24 Oct, 2021",
    image_url: "/assets/images/blog-demo.png"
  },
  {
    title: "A symbol of hope for global unity 18",
    date: "24 Oct, 2021",
    image_url: "/assets/images/blog-demo.png"
  },
  {
    title: "A symbol of hope for global unity 19",
    date: "24 Oct, 2021",
    image_url: "/assets/images/blog-demo.png"
  },
  {
    title: "A symbol of hope for global unity 20",
    date: "24 Oct, 2021",
    image_url: "/assets/images/blog-demo.png"
  },
  {
    title: "A symbol of hope for global unity 22",
    date: "24 Oct, 2021",
    image_url: "/assets/images/blog-demo.png"
  },
  {
    title: "A symbol of hope for global unity 23",
    date: "24 Oct, 2021",
    image_url: "/assets/images/blog-demo.png"
  },
  {
    title: "A symbol of hope for global unity 1",
    date: "24 Oct, 2021",
    image_url: "/assets/images/blog-demo.png"
  },
  {
    title: "A symbol of hope for global unity 2",
    date: "24 Oct, 2021",
    image_url: "/assets/images/blog-demo.png"
  },
  {
    title: "A symbol of hope for global unity 3",
    date: "24 Oct, 2021",
    image_url: "/assets/images/blog-demo.png"
  },
  {
    title: "A symbol of hope for global unity 4",
    date: "24 Oct, 2021",
    image_url: "/assets/images/blog-demo.png"
  },
  {
    title: "A symbol of hope for global unity 5",
    date: "24 Oct, 2021",
    image_url: "/assets/images/blog-demo.png"
  },
  {
    title: "A symbol of hope for global unity 6",
    date: "24 Oct, 2021",
    image_url: "/assets/images/blog-demo.png"
  },
  {
    title: "A symbol of hope for global unity 7",
    date: "24 Oct, 2021",
    image_url: "/assets/images/blog-demo.png"
  },
  {
    title: "A symbol of hope for global unity 8",
    date: "24 Oct, 2021",
    image_url: "/assets/images/blog-demo.png"
  },
  {
    title: "A symbol of hope for global unity 9",
    date: "24 Oct, 2021",
    image_url: "/assets/images/blog-demo.png"
  },
  {
    title: "A symbol of hope for global unity 10",
    date: "24 Oct, 2021",
    image_url: "/assets/images/blog-demo.png"
  },
  {
    title: "A symbol of hope for global unity 11",
    date: "24 Oct, 2021",
    image_url: "/assets/images/blog-demo.png"
  },
  {
    title: "A symbol of hope for global unity 12",
    date: "24 Oct, 2021",
    image_url: "/assets/images/blog-demo.png"
  },
  {
    title: "A symbol of hope for global unity 13",
    date: "24 Oct, 2021",
    image_url: "/assets/images/blog-demo.png"
  },
  {
    title: "A symbol of hope for global unity 14",
    date: "24 Oct, 2021",
    image_url: "/assets/images/blog-demo.png"
  },
  {
    title: "A symbol of hope for global unity 15",
    date: "24 Oct, 2021",
    image_url: "/assets/images/blog-demo.png"
  },
  {
    title: "A symbol of hope for global unity 16",
    date: "24 Oct, 2021",
    image_url: "/assets/images/blog-demo.png"
  },
  {
    title: "A symbol of hope for global unity 17",
    date: "24 Oct, 2021",
    image_url: "/assets/images/blog-demo.png"
  },
  {
    title: "A symbol of hope for global unity 18",
    date: "24 Oct, 2021",
    image_url: "/assets/images/blog-demo.png"
  },
  {
    title: "A symbol of hope for global unity 19",
    date: "24 Oct, 2021",
    image_url: "/assets/images/blog-demo.png"
  },
  {
    title: "A symbol of hope for global unity 20",
    date: "24 Oct, 2021",
    image_url: "/assets/images/blog-demo.png"
  },
  {
    title: "A symbol of hope for global unity 22",
    date: "24 Oct, 2021",
    image_url: "/assets/images/blog-demo.png"
  },
  {
    title: "A symbol of hope for global unity 23",
    date: "24 Oct, 2021",
    image_url: "/assets/images/blog-demo.png"
  },
  {
    title: "A symbol of hope for global unity 1",
    date: "24 Oct, 2021",
    image_url: "/assets/images/blog-demo.png"
  },
  {
    title: "A symbol of hope for global unity 2",
    date: "24 Oct, 2021",
    image_url: "/assets/images/blog-demo.png"
  },
  {
    title: "A symbol of hope for global unity 3",
    date: "24 Oct, 2021",
    image_url: "/assets/images/blog-demo.png"
  },
  {
    title: "A symbol of hope for global unity 4",
    date: "24 Oct, 2021",
    image_url: "/assets/images/blog-demo.png"
  },
  {
    title: "A symbol of hope for global unity 5",
    date: "24 Oct, 2021",
    image_url: "/assets/images/blog-demo.png"
  },
  {
    title: "A symbol of hope for global unity 6",
    date: "24 Oct, 2021",
    image_url: "/assets/images/blog-demo.png"
  },
  {
    title: "A symbol of hope for global unity 7",
    date: "24 Oct, 2021",
    image_url: "/assets/images/blog-demo.png"
  },
  {
    title: "A symbol of hope for global unity 8",
    date: "24 Oct, 2021",
    image_url: "/assets/images/blog-demo.png"
  },
  {
    title: "A symbol of hope for global unity 9",
    date: "24 Oct, 2021",
    image_url: "/assets/images/blog-demo.png"
  },
  {
    title: "A symbol of hope for global unity 10",
    date: "24 Oct, 2021",
    image_url: "/assets/images/blog-demo.png"
  },
  {
    title: "A symbol of hope for global unity 11",
    date: "24 Oct, 2021",
    image_url: "/assets/images/blog-demo.png"
  },
  {
    title: "A symbol of hope for global unity 12",
    date: "24 Oct, 2021",
    image_url: "/assets/images/blog-demo.png"
  },
  {
    title: "A symbol of hope for global unity 13",
    date: "24 Oct, 2021",
    image_url: "/assets/images/blog-demo.png"
  },
  {
    title: "A symbol of hope for global unity 14",
    date: "24 Oct, 2021",
    image_url: "/assets/images/blog-demo.png"
  },
  {
    title: "A symbol of hope for global unity 15",
    date: "24 Oct, 2021",
    image_url: "/assets/images/blog-demo.png"
  },
  {
    title: "A symbol of hope for global unity 16",
    date: "24 Oct, 2021",
    image_url: "/assets/images/blog-demo.png"
  },
  {
    title: "A symbol of hope for global unity 17",
    date: "24 Oct, 2021",
    image_url: "/assets/images/blog-demo.png"
  },
  {
    title: "A symbol of hope for global unity 18",
    date: "24 Oct, 2021",
    image_url: "/assets/images/blog-demo.png"
  },
  {
    title: "A symbol of hope for global unity 19",
    date: "24 Oct, 2021",
    image_url: "/assets/images/blog-demo.png"
  },
  {
    title: "A symbol of hope for global unity 20",
    date: "24 Oct, 2021",
    image_url: "/assets/images/blog-demo.png"
  },
  {
    title: "A symbol of hope for global unity 22",
    date: "24 Oct, 2021",
    image_url: "/assets/images/blog-demo.png"
  },
  {
    title: "A symbol of hope for global unity 23",
    date: "24 Oct, 2021",
    image_url: "/assets/images/blog-demo.png"
  },
  {
    title: "A symbol of hope for global unity 1",
    date: "24 Oct, 2021",
    image_url: "/assets/images/blog-demo.png"
  },
  {
    title: "A symbol of hope for global unity 2",
    date: "24 Oct, 2021",
    image_url: "/assets/images/blog-demo.png"
  },
  {
    title: "A symbol of hope for global unity 3",
    date: "24 Oct, 2021",
    image_url: "/assets/images/blog-demo.png"
  },
  {
    title: "A symbol of hope for global unity 4",
    date: "24 Oct, 2021",
    image_url: "/assets/images/blog-demo.png"
  },
  {
    title: "A symbol of hope for global unity 5",
    date: "24 Oct, 2021",
    image_url: "/assets/images/blog-demo.png"
  },
  {
    title: "A symbol of hope for global unity 6",
    date: "24 Oct, 2021",
    image_url: "/assets/images/blog-demo.png"
  },
  {
    title: "A symbol of hope for global unity 7",
    date: "24 Oct, 2021",
    image_url: "/assets/images/blog-demo.png"
  },
  {
    title: "A symbol of hope for global unity 8",
    date: "24 Oct, 2021",
    image_url: "/assets/images/blog-demo.png"
  },
  {
    title: "A symbol of hope for global unity 9",
    date: "24 Oct, 2021",
    image_url: "/assets/images/blog-demo.png"
  },
  {
    title: "A symbol of hope for global unity 10",
    date: "24 Oct, 2021",
    image_url: "/assets/images/blog-demo.png"
  },
  {
    title: "A symbol of hope for global unity 11",
    date: "24 Oct, 2021",
    image_url: "/assets/images/blog-demo.png"
  },
  {
    title: "A symbol of hope for global unity 12",
    date: "24 Oct, 2021",
    image_url: "/assets/images/blog-demo.png"
  },
  {
    title: "A symbol of hope for global unity 13",
    date: "24 Oct, 2021",
    image_url: "/assets/images/blog-demo.png"
  },
  {
    title: "A symbol of hope for global unity 14",
    date: "24 Oct, 2021",
    image_url: "/assets/images/blog-demo.png"
  },
  {
    title: "A symbol of hope for global unity 15",
    date: "24 Oct, 2021",
    image_url: "/assets/images/blog-demo.png"
  },
  {
    title: "A symbol of hope for global unity 16",
    date: "24 Oct, 2021",
    image_url: "/assets/images/blog-demo.png"
  },
  {
    title: "A symbol of hope for global unity 17",
    date: "24 Oct, 2021",
    image_url: "/assets/images/blog-demo.png"
  },
  {
    title: "A symbol of hope for global unity 18",
    date: "24 Oct, 2021",
    image_url: "/assets/images/blog-demo.png"
  },
  {
    title: "A symbol of hope for global unity 19",
    date: "24 Oct, 2021",
    image_url: "/assets/images/blog-demo.png"
  },
  {
    title: "A symbol of hope for global unity 20",
    date: "24 Oct, 2021",
    image_url: "/assets/images/blog-demo.png"
  },
  {
    title: "A symbol of hope for global unity 22",
    date: "24 Oct, 2021",
    image_url: "/assets/images/blog-demo.png"
  },
  {
    title: "A symbol of hope for global unity 23",
    date: "24 Oct, 2021",
    image_url: "/assets/images/blog-demo.png"
  }
]




